import { RepeatComponent } from '@common-modules/shared-component/repeat/repeat.component';
import { SvgEditorFieldTypeComponent } from '@common-modules/svg-editor/svg-editor-field-type/svg-editor-field-type.component';
import { TypeOption } from '@ngx-formly/core/lib/models';
import { ChipsInputTypeComponent } from './types/chips-input-type/chips-input-type.component';
import { ChipsSelectorTypeComponent } from './types/chips-selector-type/chips-selector-type.component';
import { ColorPickerTypeComponent } from './types/color-picker-type/color-picker-type.component';
import { FamilyRelationsFieldTypeComponent } from './types/family-relations-field-type/family-relations-field-type.component';
import { FileUploadTypeComponent } from './types/file-upload-type/file-upload-type.component';
import { InputWithIconComponent } from './types/input-with-icon/input-with-icon.component';
import { SwitcherTypeComponent } from './types/switcher-type/switcher-type.component';
import { TextEditorTypeComponent } from './types/text-editor-type/text-editor-type.component';
import { TreeDropdownTypeComponent } from './types/tree-dropdown-type/tree-dropdown-type.component';

export const configurableFormTypes: TypeOption[] = [
  {
    name: 'chips-selector',
    component: ChipsSelectorTypeComponent,
    wrappers: ['form-field'],
  },
  {
    name: 'chips-input',
    component: ChipsInputTypeComponent,
    wrappers: ['form-field'],
  },
  {
    name: 'color-picker',
    component: ColorPickerTypeComponent,
    wrappers: ['form-field'],
  },
  {
    name: 'color-picker-no-wrapper',
    component: ColorPickerTypeComponent,
  },
  {
    name: 'file-upload',
    component: FileUploadTypeComponent,
  },
  {
    name: 'switcher',
    component: SwitcherTypeComponent,
    wrappers: [],
  },
  {
    name: 'tree-dropdown',
    component: TreeDropdownTypeComponent,
    wrappers: ['form-field'],
  },
  {
    name: 'repeat',
    component: RepeatComponent,
  },
  {
    name: 'input-with-icon',
    component: InputWithIconComponent,
    wrappers: ['form-field'],
  },
  {
    name: 'svg-editor',
    component: SvgEditorFieldTypeComponent,
  },
  {
    name: 'het-sorter-selector',
    component: FamilyRelationsFieldTypeComponent,
  },
  {
    name: 'text-editor',
    component: TextEditorTypeComponent,
  },
];
